import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { UserAvatar } from '@/components/UserAvatar.tsx'
import { Label } from '@/components/ui/label.tsx'
import { DEFAULT_STORY } from '@/constants/DEFAULT_VALUES.ts'

type Props = {
  storyId: string
  value?: Member
}

export const RequestedBy = ({ storyId, value = { ...DEFAULT_STORY().requestedBy } }: Props) => {
  return (
    <>
      <Label htmlFor={`requested-by-${storyId}`} variant="title">
        Requester
      </Label>
      <div className="flex items-center justify-between gap-1">
        <UserAvatar member={value} size="xs" />
        <span id={`requested-by-${storyId}`} className="font-EN-KR-body2-regular text-contents-primary truncate">
          {value.name}
        </span>
      </div>
    </>
  )
}

export const TypedEditableRequestedBy = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<Member, ComponentProps<typeof RequestedBy>, undefined> & RefAttributes<EditableCommands>
>
